import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { UserService } from './user.service';

import { EbUser } from '../classes/user';
import { EtatUser, Modules, UserRole, ServiceType, AccessRights } from '../utils/enumeration';
import { AuthenticationService } from './authentication.service';
import { ConnectedUserComponent } from '../shared/connectedUserComponent';
import { Observable } from 'rxjs/Observable';
import { SearchCriteria } from '../utils/searchCriteria';

@Injectable()
export class UserAuthGuardService implements CanActivate {

	userConnected: EbUser;
	etatUser = EtatUser;
	isLoggedIn: Observable<boolean>;


	constructor( private auth: AuthenticationService, private router: Router, private userService: UserService) {
		//this.isLoggedIn = this.auth.isLoggedInObservable;
	}

	canActivate(next:ActivatedRouteSnapshot, state:RouterStateSnapshot)
	{
		let isAuthenticated = AuthenticationService.isAuthenticated();

		if (isAuthenticated) {
			this.userConnected = AuthenticationService.getConnectedUser();

			if(this.hasAccess(state.url))
				return true;
			else{
				this.router.navigate(['accueil']);
				return false;
			}
		}
		else {
			this.router.navigate(['login']);
			return false;
		}
	}

	hasAccess(url: string){
		let ecModule = null;

		if(url.indexOf("/pricing/") >= 0)
			ecModule = Modules.PRICING;
		else if(url.indexOf("/transport-management/") >= 0)
			ecModule = Modules.TRANSPORT_MANAGEMENT;
		// else if(url.indexOf("/compliance-matrix") >= 0)
		// 	ecModule = Modules.COMPLIANCE_MATRIX;
		else return true;

		if(!this.userConnected)
			return false;

		if(ecModule == Modules.COMPLIANCE_MATRIX && this.userConnected.role != UserRole.CHARGEUR)
			return false;

		if(url.indexOf("/pricing/creation") >= 0 && this.userConnected.role == UserRole.PRESTATAIRE)
			return true;

		if(!this.userConnected.listAccessRights || this.userConnected.listAccessRights.length == 0)
			return false;

		return this.userConnected.listAccessRights.find(access => {
			if(access.module.ecModuleNum == ecModule && access.accessRight == AccessRights.NON_VISIBLE)
				return true;
			if(access.module.ecModuleNum == ecModule && url.indexOf("/creation") >= 0 && access.accessRight == AccessRights.VISUALISATION)
				return true;
		}) ? false : true;
	}
}



// WEBPACK FOOTER //
// ./src/app/services/user-auth-guard.service.ts